import { useDispatch, useSelector } from "react-redux";
import Header from "./header";
import {
  Increament,
  Decreament,
  fetchMockData,
} from "../store/actions/counter";
import { useEffect } from "react";
import Input from "./inputComponent";

function Counter() {
  const counter = useSelector((state) => state?.counter);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchMockData(dispatch);
  }, []);

  return (
    <div className="App">
      <Header />
      <Input />
      <p>Counter Value:- {counter?.value}</p>
      <button onClick={() => Increament(dispatch)} class="button medium">
        Increase
      </button>
      <button onClick={() => Decreament(dispatch)} class="button medium">
        Decrease
      </button>
    </div>
  );
}

export default Counter;
